import { z } from "zod";

/**
 * V2 feature #2's "money to review" queue contract — GET /v2/reconciliation,
 * POST /v2/reconciliation/:id/resolve, POST /v2/reconciliation/run. Mirrors
 * app/api/v2/reconciliation.py's ReconciliationFlagOut / ReconciliationListOut
 * / ReconcileRunOut pydantic schemas exactly.
 */

export const ReconciliationStatusSchema = z.enum(["open", "resolved", "ignored"]);
export type ReconciliationStatus = z.infer<typeof ReconciliationStatusSchema>;

export const ReconciliationFlagSchema = z.object({
  id: z.string(),
  kind: z.string(),
  status: ReconciliationStatusSchema,
  stripe_object_id: z.string().nullable(),
  amount_cents: z.number().nullable(),
  invoice_id: z.string().nullable(),
  event_id: z.string().nullable(),
  detail: z.string().nullable(),
  resolved_by: z.string().nullable(),
  resolved_at: z.string().nullable(),
  resolution_note: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
});
export type ReconciliationFlag = z.infer<typeof ReconciliationFlagSchema>;

export const ReconciliationListResponseSchema = z.object({
  items: z.array(ReconciliationFlagSchema),
});
export type ReconciliationListResponse = z.infer<typeof ReconciliationListResponseSchema>;

export interface ResolveFlagInput {
  id: string;
  note?: string;
  ignore?: boolean;
}

export const ReconcileRunResultSchema = z.object({
  enabled: z.boolean(),
  scanned: z.number(),
  flagged: z.number(),
  since: z.string(),
});
export type ReconcileRunResult = z.infer<typeof ReconcileRunResultSchema>;
